var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('zaheader'),_c('router-view'),_c('zafooter',{attrs:{"dados":_vm.siteConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }